module.exports = __webpack_public_path__ + "static/media/soccer.f8a7bc77.png";